import {
    Component,
    forwardRef,
    ViewChild,
    ElementRef,
    ViewEncapsulation, Input
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'ft-input-toggle',
    templateUrl: './input-toggle.component.html',
    styleUrls: ['./input-toggle.component.scss'],
    imports: [CommonModule, FormsModule, MatIconModule],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputToggleComponent),
            multi: true
        }
    ]
})
export class InputToggleComponent implements ControlValueAccessor {
    @ViewChild('textElement') textElement: ElementRef<HTMLSpanElement>;
    @ViewChild('inputElement') inputElement: ElementRef<HTMLInputElement>;
    @Input() placeholder: string;

    value: string = '';
    isEditMode: boolean = false;
    disabled: boolean = false;
    animated: boolean = false;

    private onChange: (value: string) => void = () => {
    };
    private onTouched: () => void = () => {
    };

    // ControlValueAccessor methods
    writeValue(value: string): void {
        this.value = value || '';
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onInputChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        this.value = target.value;
        this.onChange(this.value);
    }

    onInputFocus(): void {
        this.animated = true;
        this.isEditMode = true;
    }

    onInputBlur(): void {
        this.isEditMode = false;
        this.onTouched();
    }

    get inputWidth() {
        if (this.textElement) {
            return this.textElement.nativeElement.offsetWidth;
        }
        return 100;
    }
}
